import React from "react";
import ReactDOM from "react-dom/client";
import "./Assets/Styles/Style.css";
import "./hr-erp-design.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "./index.css";
import { setupAxiosAuthInterceptor } from "./setupAxiosAuthInterceptor";
import { setupAxiosApplicationKey } from "./setupAxiosApplicationKey";

setupAxiosAuthInterceptor();
setupAxiosApplicationKey();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Toaster />
    <App />
  </>
);
reportWebVitals();
